import { AxiosInstance } from 'axios';
import { axiosProxy } from '@/plugins/axios';
import { Gallery } from './Gallery';
import { GalleryTransformer } from './GalleryTransformer';

export class GalleryRepository {

  private api: AxiosInstance = axiosProxy;

  async getGalleries(page: number = 1): Promise<Gallery[]> {
    try {
      const res = await this.api.get(`artists?page=${page}`);
      if (res.data['data']) {
        // return res.data[]new GalleryTransformer().toClass(res.data['data']);
        return [];
      }
      throw Error("Data is not array");
    } catch (error) {
      throw error;
    }
  }

  async getGallery(slug: string): Promise<Gallery> {
    try {
      const res = await this.api.get(`galleries/${slug}?include=media,artworks.media`);
      if (res.data['data']) {
        return new GalleryTransformer().toClass(res.data['data']);
      }
      throw Error("Data is not array");
    } catch (error) {
      throw error;
    }
  }

}
